import $ from 'jquery';
import './model.scss';
import 'modules/products/v2_0/tires/price-and-shop';
import './../components/RecallAlert/recallAlert.scss';
import Subnav from './../shared/Subnav';
import OverallScore from './../components/OverallScore';
import './../components/RecommendationLabel';
import ModelNav from './../components/ModelNav';
import {CompareBucketRedux} from './../components/CompareBucketRedux';
import userReviews from './../components/UserReviews';
import './../components/BrandReliability';
import './../components/RatingsBlob';
import './../components/RatingsHighsLows';
import './../components/RatingsScorecard';
import './../components/RatingsText';
import Tooltip from '../../../shared/components/Tooltip';
import './../components/FeaturesSpecs';
import News from './../shared/News';
import './../shared/DnaModelAlert'
import Price from '../components/Price/index';
import './../shared/AjaxLoadingIndicator';
import './../shared/PriceAndShopTable';
import Gallery from 'modules/shared/Gallery/index.js';
import SimilarModule from './../components/SimilarModule';
import SiteCatalyst from './../components/SiteCatalyst/model';
import ExpiredLogin from './../components/ExpiredLogin';
import MembershipPageUpdate from './../components/MembershipPageUpdate';
import './model-print.scss';

$(function () {
    Subnav();
    OverallScore();
    Gallery();
    ModelNav();
    CompareBucketRedux();
    userReviews();
    News();
    Price();
    SimilarModule();
    Tooltip();
    SiteCatalyst(window.initStore.seo);
    ExpiredLogin();
    MembershipPageUpdate();
});



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/model/App.js